import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'
import { mapConnectionCodeDto } from '../../../mapping/account'

const dataApi = DataApi.getInstance()

export default function useGetConnectionCode() {
  const texts = useTranslation().t

  const query = useQuery([queryNames.getConnectionCode], async () => {
    const { data } = await dataApi.getConnectionCode()
    return mapConnectionCodeDto(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })

  return query
}
